import { useMemo } from "react";

import { useNetworkMetadata } from "Flocknote/apiHooks";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import FnrTypography from "FnrTypography";

import { useHeaderTextColor } from "../stateHooks";

const Header = () => {
  const textColor = useHeaderTextColor();
  const [{ networkName }] = useNetworkMetadata();
  const { contextInquiryText } = useMemberToobarContext();

  const { flocknoteSupport, generalInquiry, prayerRequest } =
    useMemberToobarContext();

  const text = useMemo(() => {
    if (generalInquiry) return `Contact ${networkName}`;
    if (prayerRequest) return "How can we pray for you?";
    if (flocknoteSupport) return "Contact Flocknote Support";
    return contextInquiryText;
  }, [
    contextInquiryText,
    flocknoteSupport,
    generalInquiry,
    networkName,
    prayerRequest,
  ]);

  return (
    <FnrTypography
      lineHeight={1.1}
      italic
      color={textColor}
      type="header"
      fontSize="lg"
    >
      {text}
    </FnrTypography>
  );
};

export default Header;
